import { render } from "./DamageItem.vue?vue&type=template&id=bbaf56c0&scoped=true"
import script from "./DamageItem.vue?vue&type=script&lang=js"
export * from "./DamageItem.vue?vue&type=script&lang=js"

import "./DamageItem.vue?vue&type=style&index=0&id=bbaf56c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbaf56c0"]])

export default __exports__